( function ( $ ) {
	var $glossaryButton = $( '.js-glossary-button' );

	$glossaryButton.each( function () {
		$( this ).on( 'click', function ( event ) {
			var $container = $( '.js-glossary-content-container' );
			var letter = $( this ).attr( 'data-letter' );
			var $scrollTo = $( `.js-glossary-item-${letter}` );

			$container.animate(
				{ scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop() },
				400
			);
			$glossaryButton.removeClass( 'glossary__button--clicked' );
			$( this ).addClass( 'glossary__button--clicked' );
		} );
	} );

} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/partials/glossary.js